module.exports = __webpack_public_path__ + "img/aboutimg01@2x.d545f7ab.png";